import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class POSService {

    constructor(private api: ApiService) {
    }

    getMembers(query?: any) {
        return this.api.get(this.api.path + '/pos', query);
    }

    insert(data: any) {
        return this.api.post(this.api.path + '/pos', data);
    }

    update(id: any, data: any) {
        return this.api.post(this.api.path + '/pos/' + id, data);
    }

    delete(id: any) {
        return this.api.delete(this.api.path + '/pos/' + id);
    }

    getMemberOverview(id: number) {
        return this.api.get(this.api.path + '/pos/' + id + '/overview');
    }

    getMemberWallet(id: number) {
        return this.api.get(this.api.path + '/pos/' + id + '/wallet');
    }

    getMember(id: number) {
        return this.api.get(this.api.path + '/pos/' + id);
    }

    getMemberTransactions(id: number, query?: any) {
        return this.api.get(this.api.path + '/transaction/', { ...query, ...{ userId: id } });
    }

    getMemberCoupons(id: number, query?: any) {
        return this.api.get(this.api.path + '/coupon/', { ...query, ...{ userId: id } });
    }

    getMemberBonusRules(id: number, query?: any) {
        return this.api.get(this.api.path + '/pos/' + id + '/bonus', query);
    }

    getMemberNotes(id: number, query?: any) {
        return this.api.get(this.api.path + '/pos/' + id + '/note', query);
    }

    insertMemberNote(id: number, data: any) {
        return this.api.post(this.api.path + '/pos/' + id + '/note', data);
    }

    getMemberLimits(id: number, query?: any) {
        return this.api.get(this.api.path + '/pos/' + id + '/limit', query);
    }

    getMemberAccessLogs(id: number, query?: any) {
        return this.api.get(this.api.path + '/pos/' + id + '/access', query);
    }

    addMember(data: any) {
        return this.api.post(this.api.path + '/pos', data);
    }

    getUserOptions(query?: any) {
        return this.api.get(this.api.path + '/pos/option', query);
    }

    updateUserOption(id: any, userId: any, formData: any) {
        return this.api.post(this.api.path + '/pos/' + userId + '/option/' + id, formData);
    }

    updatePOSConfig(id: any, data: any) {
        return this.api.post(this.api.path + '/pos/' + id + '/config', data);
    }

    getMemberTokens(userId: number, query?: any) {
        return this.api.get(this.api.path + '/pos/' + userId + '/token', query);
    }

    addMemberToken(userId: number, formData: any) {
        return this.api.post(this.api.path + '/pos/' + userId + '/token/', formData);
    }

    deactivateMemberToken(id: number) {
        return this.api.post(this.api.path + '/pos/token/deactivate', { userAccessTokenId: id });
    }

    updateMemberTokenBalance(id: number, formData: any) {
        return this.api.post(this.api.path + '/pos/token/balance', { userAccessTokenId: id, ...formData });
    }
}
